import { render } from "./Post.vue?vue&type=template&id=8a6d3508"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=8a6d3508&lang=css"

import exportComponent from "/Users/smithy/Development/Kfzapp Development/kfzapp-idea-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__